module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronoun"
    }
  }), _vm._v(" gegevens")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.salutation) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.initials) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.firstname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.nickname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.middlename) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.lastname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.date_of_birth) + "\r\n                      ")])])])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(8), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.address) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.postcode) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.city) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.country) + "\r\n                  ")])])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(13), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.email) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_mobile) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_home) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_work) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_contact) + "\r\n                  ")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('passport', {
    attrs: {
      "passenger": _vm.user,
      "isLoading": _vm.isLoading
    },
    on: {
      "reload": _vm.fetchData
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Persoonsgegevens "), _c('i', {
    staticClass: "fa fa-user pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Aanhef")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Voorletters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Officiële voornamen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Voornaam")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tussenvoegsels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Achternaam")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geboortedatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Adresgegevens "), _c('i', {
    staticClass: "fa fa-address-book pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Adres")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Postcode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Plaats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Land")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Contactgegevens "), _c('i', {
    staticClass: "fa fa-phone pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. mobiel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. thuis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. werk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. thuisblijver")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5167ae78"}!./src/templates/portal/personal-info.html
// module id = 538
// module chunks = 1